import React, { useState } from "react";
import { MdEmail, MdLock } from "react-icons/md"; // Importando Material Icons
import "../styles/Login.css";

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin(email, password);
  };

  return (
    <div className="login-container">
      <h1>Acesse sua conta</h1> {/* Novo título principal para SEO */}
      <h2>Login</h2>
      <form onSubmit={handleSubmit}>
        <div className="input-group">
          <MdEmail size={24} color="#007bff" />
          <input
            type="email"
            placeholder="Digite seu e-mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="input-group">
          <MdLock size={24} color="#007bff" />
          <input
            type="password"
            placeholder="Digite sua senha"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <button type="submit" className="button">Entrar</button>
      </form>
    </div>
  );
};

export default Login;
